import script from "./TimeTableView.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeTableView.vue?vue&type=script&setup=true&lang=js"

import "./TimeTableView.vue?vue&type=style&index=0&id=1cf40f19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf40f19"]])

export default __exports__